export default {
  clocked_in: false,
  timepunches: [],
}
